


































import {Component, Watch, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import CalendarType from '@/models/Shared/CalendarType';
import ListUtils from '@/lib/listUtils';
import DateTimeUtils from '@/lib/dateTimeUtils';
import OpenEntityInNewWindowBtn from '../Shared/OpenEntityInNewWindowBtn.vue';
import { AgencyScheduleModule } from '@/store/modules/agencySchedule';
import JobWorkerInterviewStatus from '@/models/JobWorkerInterviews/JobWorkerInterviewStatus';
import JobScheduleEventViewModel from '@/models/Jobs/JobScheduleEventViewModel';
import JobScheduleEventType from '@/models/Jobs/JobScheduleEventType';

@Component({
  name: 'JobSchedule', components: {OpenEntityInNewWindowBtn  }
})
export default class extends GiganautVue {

	JobScheduleEventType = JobScheduleEventType;

	get calendarType() {
		return AgencyScheduleModule.filterJobScheduleViewModel.calendarType;
	}

	set calendarType(calendarType: string) {
		AgencyScheduleModule.filterJobScheduleViewModel.calendarType;
	}

	get date() {
		return AgencyScheduleModule.currentJobScheduleSearchCriteria.from;
	}

	get eventHeight() {
		return 40;
	}
    
	get events() {
		return AgencyScheduleModule.jobEvents;
	} 

	eventClicked(event: JobScheduleEventViewModel) {
		window.open(window.location.origin + "/agency/jobs/" + event.jobId);
	}

	eventColor(event: JobScheduleEventViewModel){
		let color = "primary";
		if (event.type === JobScheduleEventType.Interview) {

			switch (event.interviewStatus) {
				case JobWorkerInterviewStatus.PartiallyConfirmed:
				case JobWorkerInterviewStatus.PendingConfirmation:
					color = "orange";
					break;
				case JobWorkerInterviewStatus.FullyConfirmed:
				case JobWorkerInterviewStatus.Completed:
					color = "green";
					break;
				case JobWorkerInterviewStatus.Cancelled:
					color = "red";
					break;
			}
		}
		return color;
	}

	eventTextColor(event: JobScheduleEventViewModel){
		let color = "white";
		if (event.type === JobScheduleEventType.Interview) {
			switch (event.interviewStatus) {
				case JobWorkerInterviewStatus.PendingConfirmation:
				case JobWorkerInterviewStatus.PartiallyConfirmed:
				case JobWorkerInterviewStatus.FullyConfirmed:
				case JobWorkerInterviewStatus.Completed:
					color = "black";
					break;
				case JobWorkerInterviewStatus.Cancelled:
					color = "white";
					break;
			}
		}
		return color;
	}

	get weekdays() {
		return [1, 2, 3, 4, 5, 6, 0];
	}

	get calendarTypes() {
		return ListUtils.calendarTypes();
	}

	async next() {
		//@ts-ignore
		this.$refs.calendar.next()
	}

	async prev() {
		//@ts-ignore
		this.$refs.calendar.prev()
	}

}
